module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_ext_04_6NW26_1SC_G9K.047d1f17.png";